import { render, staticRenderFns } from "./InstrumentFile.vue?vue&type=template&id=8a8fd2b6&scoped=true"
import script from "./InstrumentFile.vue?vue&type=script&lang=ts"
export * from "./InstrumentFile.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentFile.vue?vue&type=style&index=0&id=8a8fd2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8fd2b6",
  null
  
)

export default component.exports